(function(root, factory) {
    if(typeof define === 'function' && define.amd) {
        define(factory);
    } else if(typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.Cnil = factory();
    }
}) (this, function() {

    'use strict';

    // Options and their defaults
    var settings = {
        consentCookie: 'ga_consent',
        texts: {
            message: 'En poursuivant votre navigation sur ce site, vous acceptez l’utilisation de Cookies qui nous permettent de mesurer l\'audience de notre site et de vous proposer des contenus et services adaptés à vos centres d’intérêt.',
            comment: 'Pour en savoir plus, <a href="/mentions-legales">cliquez ici</a>',
            consent: 'Ok'
        }
    };

    var banner;

    var initialize = function(options) {
        for(var prop in options) {
            if(typeof settings[prop] === 'object') {
                for(var prop2 in options[prop]) {
                    settings[prop][prop2] = options[prop][prop2];
                }
            } else {
                settings[prop] = options[prop];
            }
        }

        var userConsent = getCookie(settings.consentCookie);

        if(userConsent === undefined || userConsent === 'null') {
            updateConsentCookie('null');
            createBanner(document.documentElement.lang);
        }
    };

    var updateConsentCookie = function(value) {
        var cookieString = settings.consentCookie + '=' + value;
        cookieString += ';path=' + '/';
        cookieString += ';domain=' + window.location.hostname;
        cookieString += ';expires=' + (new Date(new Date().getTime() + 390 * 24 * 60 * 60 * 1000)).toUTCString();

        document.cookie = cookieString;
    };

    var acceptCookies = function() {
        updateConsentCookie(1);
        banner.parentNode.removeChild(banner);
    };

    var getCookie = function(name) {
        var cookies = document.cookie.split('; ');
        for(var i = 0; i < cookies.length; i++){
            var cookie = cookies[i].split('=');
            if(cookie[0] === name)
                return cookie[1];
        }

        return undefined;
    };

    var createBanner = function(lang) {
        banner = document.createElement('div');
            banner.id = 'cnil-banner';
            banner.className = 'cnil-banner';
        var inner = document.createElement('div');
            inner.className = 'cnil-banner__inner';
        var message = document.createElement('p');
            message.className = 'cnil-banner__message';
            message.innerHTML = getLocalizeText('message', lang);
        var comment = document.createElement('p');
            comment.className = 'cnil-banner__options';
            comment.innerHTML = getLocalizeText('comment', lang);
        var button = document.createElement('button');
            button.className = 'cnil-banner__consent-btn';
            button.innerHTML = getLocalizeText('consent', lang);

        inner.appendChild(message);
        inner.appendChild(comment);
        inner.appendChild(button);
        banner.appendChild(inner);

        button.addEventListener('click', function(e){
            updateConsentCookie(1);
            banner.parentNode.removeChild(banner);
        });

        document.body.appendChild(banner);
    };

    var getLocalizeText = function(prop, lang) {
        var text;

        if(settings.texts[prop][lang] !== undefined)
            text = settings.texts[prop][lang];
        else if(settings.texts[prop] !== undefined)
            text = settings.texts[prop];
        else
            text = '';

        return text;
    };

    return {
        init: initialize
    };

});
